import React, { useState } from 'react';
import { Card, CardContent, Typography, Button, TextField, RadioGroup, FormControlLabel, Radio, Box, Collapse, Alert, Chip } from '@mui/material';
import api from '../../api';

const FeedbackCard = ({ qaPair, questionLabel = 'Text', answerLabel = 'Answer', reviewerEmail, onFeedbackSuccess, isSubmitted }) => {
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!status) {
      setError('Please select "Approve" or "Decline".');
      return;
    }
    setError('');
    try {
      await api.post('/feedback', {
        qa_pair_id: qaPair.id,
        reviewer_email: reviewerEmail,
        status,
        message,
      });
      onFeedbackSuccess(qaPair.id);
    } catch (err) {
      console.error("Submit feedback error:", err);
      setError(err.response?.data?.message || 'Failed to submit feedback.');
    }
  };

  const displayQuestion = (qaPair.metadata && qaPair.metadata.question_html) ? qaPair.metadata.question_html : qaPair.text;
  const displayAnswer = (qaPair.metadata && qaPair.metadata.answer_html) ? qaPair.metadata.answer_html : qaPair.answer;
  const category = qaPair.metadata ? (qaPair.metadata.category || qaPair.metadata.Category || qaPair.metadata.CATEGORY) : null;

  return (
    <Card sx={{ mb: 3, opacity: isSubmitted ? 0.5 : 1, pointerEvents: isSubmitted ? 'none' : 'auto' }}>
      <CardContent>
        {category && (
          <Box sx={{ mb: 1.5 }}>
            <Chip label={`Category: ${category}`} size="small" variant="outlined" color="primary" />
          </Box>
        )}
        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{questionLabel}:</Typography>
        <Typography variant="body2" paragraph dangerouslySetInnerHTML={{ __html: displayQuestion }} />
        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{answerLabel}:</Typography>
        <Typography variant="body2" paragraph dangerouslySetInnerHTML={{ __html: displayAnswer }} />

        <Collapse in={isSubmitted}>
          <Alert severity="success" sx={{ mb: 2 }}>Thank you for your feedback!</Alert>
        </Collapse>

        <Collapse in={!isSubmitted}>
          <Box mt={2}>
            {error && <Alert severity="warning" sx={{ mb: 2 }}>{error}</Alert>}
            <RadioGroup
              row
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <FormControlLabel value="approved" control={<Radio />} label="Approve" />
              <FormControlLabel value="declined" control={<Radio />} label="Decline" />
            </RadioGroup>
            <TextField
              fullWidth
              multiline
              rows={2}
              label="Your Message (optional)"
              variant="outlined"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              sx={{ mt: 2 }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{ mt: 2 }}
            >
              Submit Feedback
            </Button>
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default FeedbackCard;